module.exports = __webpack_public_path__ + "static/media/custom_bg.79964604.jpg";